// import from './polyfills'; --For static analysis
import './polyfills';
// import from './indexReactPropsType'; -- For static analysis
import './indexReactPropsType';

import React from 'react';
// import { render } from 'react-dom';
import { createRoot } from 'react-dom/client';
import { App } from './components/App/App';
import store from './store';
// import demo from './demo';
import router from './router';
import { fontCssForIcon } from './components/Icon/Icon';
import { AppState, RouterType } from 'src/AppState/AppState';
import { generateFontFace } from 'src/components/Fonts/Fonts';
import * as Sentry from '@sentry/react';
import { getAppEnvParams } from './utils/appEnvParams';
import { ReduxRawState } from './AppState/Redux/utils/ReduxRawState';
import { Common } from './AppState/Common';
import { Session } from 'src_common/sdk/session';
import { getCookie, setCookie } from './AppState/cookie';

const DEFAULT_TIMEOUT = 60 * 1000;

//@ts-expect-error
window.$store = store;

const loadFonts = (): void => {
    const head = document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    style.innerHTML = fontCssForIcon;

    const fonts = document.createElement('style');
    fonts.innerHTML = generateFontFace();

    if (head !== undefined) {
        head.appendChild(fonts);
        head.appendChild(style);
    }
};

const run = async (): Promise<void> => {
    const appEnvParams = getAppEnvParams();

    //@ts-expect-error
    const router2: RouterType = router;

    const session = await Session.start({
        websocket_api_host: appEnvParams.websocketApiHost,
        websocketUrl: appEnvParams.websocketHostV2,
        apiTimeout: DEFAULT_TIMEOUT,
        startPing: true,
        cacheApiCall: {},
        getInitJwt: (): string | null => {
            return getCookie('backoffice.sid');
        },
        setJwt: (newJwt: string): void => {
            setCookie('backoffice.sid', newJwt, 120);
        },
        refreshingJwtFromCookie: true,
    });

    const common = new Common(appEnvParams, session);

    const appState = await AppState.create(common, new ReduxRawState(store), router2);
    if (appState.isProdMode) {
        Sentry.init({
            dsn: 'https://ec64601e2576ca940b2894b5679a6b10@o4506223526936576.ingest.sentry.io/4506228830109696',
            ignoreErrors: [
                // Random plugins/extensions
                'top.GLOBALS',
                // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
                'originalCreateNotification',
                'canvas.contentDocument',
                'MyApp_RemoveAllHighlights',
                'http://tt.epicplay.com',
                "Can't find variable: ZiteReader",
                'jigsaw is not defined',
                'ComboSearch is not defined',
                'http://loading.retry.widdit.com/',
                'atomicFindClose',
                // Facebook borked
                'fb_xd_fragment',
                // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
                // reduce this. (thanks @acdha)
                // See http://stackoverflow.com/questions/4113268
                'bmi_SafeAddOnload',
                'EBCallBackMessageReceived',
                // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
                'conduitPage',
                "NotAllowedError: play() failed because the user didn't interact with the document first.",
                'Network Error',
                'SessionApi: Internal server error',
            ],
            attachStacktrace: true,
            sampleRate: 0.8,
            tracesSampleRate: 1,
            replaysSessionSampleRate: 0.4,
            replaysOnErrorSampleRate: 0.8,
            integrations: [new Sentry.Replay()],
        });
        Sentry.setTag('pbe-enviroment', 'backoffice');
        Sentry.setTag('pbe-universe', appState.universe_api);
    }

    const appJsx = (
        <App
            store={store}
            appState={appState}
            common={common}
        />
    );

    //@ts-expect-error
    window.$appState = appState;
    const container = document.getElementById('root');
    if (container !== null) {
        const root = createRoot(container);
        root.render(appJsx);
        loadFonts();
    }
};

run().catch((err) => {
    console.error(err);
});
